import React from "react";
import { PageProps } from "shared/page-props";
import * as Router from "react-router-dom";
import * as env from "shared/env";
import { ClientEmailSetup } from "./client-email-setup";
import { RefreshedClientEmailSetup } from "./client-email-setup/refreshed";
import { AgentEmailMessage } from "./agent-email-message";

interface Props extends PageProps, Router.RouteComponentProps {
}

class Component extends React.Component<Props> {

	public render() {
		const { user } = this.props;
		if (user.admin) {
			// MAX-3951: off until it ships with MAX-3948 and MAX-3952.
			return env.notificationsRefresh
				? <RefreshedClientEmailSetup {...this.props} />
				: <ClientEmailSetup {...this.props} />;
		} else {
			return <AgentEmailMessage {...this.props} />;
		}
	}
}

export const SettingsEmailPage = Component;